export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center overflow-hidden">
      {/* 顶部过渡带：从 testimonial 的 accent-50 过渡到图片 */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-accent-50/70 to-transparent pointer-events-none z-10" />
      <img
        src="https://readdy.ai/api/search-image?query=Curated%20sneaker%20collection%20displayed%20on%20floating%20glass%20shelves%20against%20warm%20neutral%20wall%20modern%20showroom%20interior%20editorial%20photography%20soft%20ambient%20lighting%20warm%20cream%20tones%20clean%20architectural%20composition%20luxury%20retail%20aesthetic%20high%20detail&width=1800&height=1000&seq=cta-sneakerwall-v2-2026&orientation=landscape"
        alt="Pandabuy spreadsheet sneaker collection wall"
        title="Explore pandabuy spreadsheet hub"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/20"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-none">
              pandabuy<br />sheet hub
            </h2>
          </div>

          <div className="flex flex-col items-start md:items-end gap-4">
            <p className="text-sm md:text-base text-background-50/80 max-w-xs text-left md:text-right leading-relaxed">
              Curated affiliate links to verified drops.<br />
              All resources open in new tab.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-background-50 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>pandabuy sheet</span>
              <div className="w-7 h-7 rounded-full bg-foreground-900 flex items-center justify-center">
                <i className="ri-arrow-right-line text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}